import React from 'react'
import { useHistory } from 'react-router'
import { FormattedMessage } from 'react-intl'
import { Button } from 'antd'
import localStorage from 'store'

const BuyAdditionalPackageButton = () => {
  const { push, location } = useHistory()

  return (
    <Button
      className="ant-btn-primary"
      onClick={() => {
        localStorage.set('redirect_after_premium', location.pathname)
        push('/billing')
      }}
    >
      <FormattedMessage id="paywall.buyAdditionalPackage" />
      <span className="icm-arrow-up upgrade-btn-text" />
    </Button>
  )
}

export default BuyAdditionalPackageButton
